import { BillIcon, CashIcon, PettyCashBudgetIcon } from '@razorpay/blade/components';
import { ComponentContainerWithBorder } from 'components/PayDetails/components/generics/ComponentContainer';
import ComponentHeader from 'components/PayDetails/components/generics/ComponentHeader';
import ComponentSection from 'components/PayDetails/components/generics/ComponentSection';
import ComponentSectionItem from 'components/PayDetails/components/generics/ComponentSectionItem';
import ComponentTable from 'components/PayDetails/components/generics/CtcBreakdownTable';
import { CtcBreakdownData } from 'components/PayDetails/types';
import React from 'react';

type CtcPreviewProps = {
  ctcData: CtcBreakdownData;
};

const CtcPreview = ({ ctcData }: CtcPreviewProps) => {
  return (
    <ComponentContainerWithBorder>
      {ctcData.fixed.data.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<CashIcon size="medium" color="surface.icon.onSea.onSubtle" />}
            iconBackground={'surface.background.sea.subtle'}
            title={'Fixed'}
            description={'Monthly earning component'}
          />
          <ComponentSectionItem>
            <ComponentTable data={ctcData.fixed} hideZeroAmountComponents={true} />
          </ComponentSectionItem>
        </ComponentSection>
      )}

      {ctcData.variable.data.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<PettyCashBudgetIcon size="medium" color="surface.icon.primary.normal" />}
            iconBackground={'surface.background.primary.subtle'}
            title={'Variable'}
            description={'Variable component based on performance, not part of monthly salary'}
          />
          <ComponentSectionItem>
            <ComponentTable data={ctcData.variable} showMonthlyColumn={false} />
          </ComponentSectionItem>
        </ComponentSection>
      )}

      {ctcData.otherCtc.data.length > 0 && (
        <ComponentSection>
          <ComponentHeader
            icon={<BillIcon size="medium" color="surface.icon.gray.normal" />}
            iconBackground={'surface.background.gray.intense'}
            title={'Other CTC component'}
            description={'Components part of CTC but not directly payable to the employee'}
          />
          <ComponentSectionItem>
            <ComponentTable data={ctcData.otherCtc} showMonthlyColumn={false} />
          </ComponentSectionItem>
        </ComponentSection>
      )}
    </ComponentContainerWithBorder>
  );
};

export default CtcPreview;
